import { Trans, t } from '@lingui/macro';
import { TextField, Form, SubmitButton } from 'shared/domains/forms';
import { Container } from './styles';
import { validationSchema } from './validationSchema';
export function NumberRangeForm(props) {
    const { onSubmit, initialValue } = props;
    return (<Form initialValues={initialValue} onSubmit={onSubmit} validationSchema={validationSchema} disableOnSubmit={false}>
      <Container>
        <TextField name="from" autoFocus label={t({ message: 'From', comment: 'Range filter: "From" input label' })} type="number"/>
        <TextField name="to" label={t({ message: 'To', comment: 'Range filter: "To" input label' })} type="number"/>
        <SubmitButton size="small">
          <Trans comment="Apply filter button label">Apply</Trans>
        </SubmitButton>
      </Container>
    </Form>);
}
